export default __webpack_public_path__ + "static/media/happy.c72c1cd4.jpeg";